import { NavLink, generatePath } from 'react-router-dom';
import {
  formatDate,
  IconAttention,
  BaseTransaction,
  BaseellaStatusTitle,
  PaymentTypeTitle,
  PaymentType,
  formatBalance,
  Currency,
} from '@ui/src';
import {
  CustomerType,
  TransactionTypeProps,
  TransactionTypeEnum,
} from '../types';

import ROUTES from '../../../routes';

import cn from '../customers.module.css';

const formatAmlTransacationList = (
  list: BaseTransaction[],
  customerId?: string,
  customerType?: CustomerType,
  transactionTypes?: TransactionTypeProps[],
  currencies?: Currency[],
): BaseTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let link = '#';
    let transactionType;

    const currentType = transactionTypes?.find(
      (type) => type.id === result.typeId,
    );

    if (currentType?.name === TransactionTypeEnum.GENERAL_LEDGER) {
      link =
        customerType === CustomerType.INDIVIDUAL
          ? ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_GL
          : ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_GL;
      transactionType = 'General Ledger';
    } else if (currentType?.name === TransactionTypeEnum.INTERNAL) {
      link =
        customerType === CustomerType.INDIVIDUAL
          ? ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL
          : ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL;

      transactionType = 'Internal';
    } else if (currentType?.name === TransactionTypeEnum.INCOMING) {
      link =
        customerType === CustomerType.INDIVIDUAL
          ? ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING
          : ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING;

      transactionType = 'Incoming';
    } else if (currentType?.name === TransactionTypeEnum.OUTGOING) {
      link =
        customerType === CustomerType.INDIVIDUAL
          ? ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING
          : ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING;
      transactionType = 'Outgoing';
    } else if (currentType?.name === TransactionTypeEnum.CURRENCY_EXCHANGE) {
      link =
        customerType === CustomerType.INDIVIDUAL
          ? ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE
          : ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE;
      transactionType = 'Exchange';
    } else if (currentType?.name === TransactionTypeEnum.NOSTRO) {
      link =
        customerType === CustomerType.INDIVIDUAL
          ? ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO
          : ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO;
      transactionType = 'Nostro';
    }

    result.url = generatePath(link, {
      customerId,
      transactionId: result.id,
    });

    const render: Record<string, React.JSX.Element> = {
      transferDate: (
        <div>{formatDate(result.transferDate as string, true)}</div>
      ),
      amount: <>{Number(result.sum).toFixed(2)}</>,
      sum: (
        <NavLink
          className={cn.accountTransactionBalance}
          to={generatePath(link, {
            customerId,
            transactionId: result.id,
          })}
        >
          <span>
            {formatBalance(
              Number(result.sum),
              currencies?.find((currency) => currency.id === result.currencyId),
            )}
          </span>
          <IconAttention />
        </NavLink>
      ),
      typeId: <div>{transactionType}</div>,
      currencyId: <div>{result.currency?.name}</div>,
      baseellaStatus: <div>{BaseellaStatusTitle[result.baseellaStatus]}</div>,
      paymentType: (
        <div>{PaymentTypeTitle[result?.paymentType as PaymentType] || '-'}</div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatAmlTransacationList;
